<template>
  <span
    v-if="filialStop"
    class="filial-stop-label"
    :class="`filial-stop-label--${variant}`"
    :title="tooltip"
  >
    <svg viewBox="0 0 24 24" class="filial-stop-label__sign" aria-hidden="true">
      <!-- Дорожный знак СТОП: восьмиугольник, единый с баджем сайдбара -->
      <polygon
        points="7.6,1.5 16.4,1.5 22.5,7.6 22.5,16.4 16.4,22.5 7.6,22.5 1.5,16.4 1.5,7.6"
        fill="#ff005f"
        stroke="#ffffff"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
      <text
        x="12"
        y="12.4"
        text-anchor="middle"
        dominant-baseline="central"
        fill="#ffffff"
        font-size="6"
        font-weight="700"
        font-family="Arial, sans-serif"
      >STOP</text>
    </svg>
    <span class="filial-stop-label__text">
      На стопе с {{ since }}<template v-if="reasonText"> · {{ reasonText }}</template>
    </span>
  </span>
</template>

<script>
  import FilialStopReason from '@/models/enums/FilialStopReason'
  import { formatIsoDateTime } from '@/util/date-time-helper'

  export default {
    name: 'FilialStopLabel',
    props: {
      // {stoppedAt, reason, reasonComment} | null - форма бэка (filialStop)
      filialStop: {
        type: Object,
        default: null,
      },
      // line - строка в подвале карточки самовывоза (как часы работы),
      // pill - таблетка в плашке адреса (как «не подключен к FAKT»)
      variant: {
        type: String,
        default: 'line',
      },
    },
    computed: {
      since () {
        return formatIsoDateTime(this.filialStop?.stoppedAt, 'HH:mm dd.MM')
      },

      reasonText () {
        if (!this.filialStop?.reason) {
          return ''
        }

        // «Другое» само по себе ничего не говорит - показываем комментарий
        if (this.filialStop.reason === FilialStopReason.Other && this.filialStop.reasonComment) {
          return this.filialStop.reasonComment
        }

        return FilialStopReason.getName(this.filialStop.reason)
      },

      tooltip () {
        return this.filialStop?.reasonComment || undefined
      },
    },
  }
</script>

<style lang="less" scoped>
.filial-stop-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: @color-pink;
  font-weight: 600;
  max-width: 100%;

  .filial-stop-label__sign {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
    display: block;
  }

  .filial-stop-label__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  // Строка в подвале карточки самовывоза - тот же ритм, что у часов работы.
  // На всю ширину и с переносом: причина «Другое» - свободный текст до 500 символов
  &--line {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    line-height: 16px;
    margin-top: 6px;

    .filial-stop-label__text {
      overflow: visible;
      white-space: normal;
      overflow-wrap: anywhere;
    }
  }

  // Таблетка в плашке адреса - тот же язык, что у «не подключен к FAKT»
  &--pill {
    font-size: 0.8rem;
    padding: 2px 8px 2px 5px;
    border: 1px solid @color-pink;
    border-radius: 100px;
    margin-left: 7px;
    // Первый flex-элемент - SVG без текстовой базовой линии: при baseline
    // таблетка садится низом значка на строку и уезжает вверх. Центруем по строке
    vertical-align: middle;
    position: relative;
    top: -2px;

    .filial-stop-label__sign {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
